export const successIcon = "sl7sa89";
export const tickIcon = "t92djo0";
export const link = "l1tt3w1f";
export const button = "b1ei6s9w";

require("./style.linaria.module.css!=!../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./style.ts");